module.exports = __webpack_public_path__ + "assets/fire.eced309cbe052acc283d8c07929eb522ffca84f21a51c10eb0bf0d1ddeaa3cfa.png";